import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        {/* Left Content */}
        <div className="hero-text">
          <h1>
            Automated Student <br />
            Attendance <br />
            Monitoring & Analytics
          </h1>
          <p className="description">
            Real-time attendance tracking for colleges with AI-powered insights,
            anomaly detection, and actionable alerts across departments.
          </p>
          <div className="hero-buttons">
            <button
              className="btn-launch"
              onClick={() => navigate("/admin-login")}
            >
              Admin Dashboard
            </button>
            <button
              className="btn-launch"
              onClick={() => navigate("/faculty-dashboard")}
            >
              Faculty Dashboard
            </button>
            <button
              className="btn-launch"
              onClick={() => navigate("/student-dashboard")}
            >
              Student Dashboard
            </button>
          </div>
        </div>

        {/* ✅ Right Image */}
        <div className="hero-image">
          <img src="/home.jpg" alt="Attendance Analytics" />
        </div>
      </div>

      {/* Features Section */}
      <section className="features-section">
        <h2 className="features-heading">Built for Modern Colleges</h2>
        <p className="features-subheading">
          Designed for scale, reliability, and real-time visibility across campus.
        </p>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📲</span>
            <h3>Instant Check-ins</h3>
            <p>
              QR/NFC-based attendance via mobile or kiosks with offline fallback.
            </p>
          </div>

          <div className="feature-card">
            <span className="feature-icon">🔔</span>
            <h3>Smart Alerts</h3>
            <p>
              Notify advisors about low attendance, no-shows, or late patterns.
            </p>
          </div>

          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Deep Analytics</h3>
            <p>
              Trends by course, semester, department, and cohort with exports.
            </p>
          </div>

          <div className="feature-card">
            <span className="feature-icon">🔗</span>
            <h3>Seamless Integrations</h3>
            <p>
              Connect your SIS/LMS to sync rosters and timetables automatically.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
